<template>
    <DashboardLayout>
        <Breadcrumb class="flex breadcrumb" :model="items" />

        <div class="card flex flex-column justify-center pt-4 px-4" style="min-height: calc(100vh - 100px);">
            <div v-if="viewStack.length > 1" class="mb-4">
                <Button label="Back" icon="pi pi-arrow-left" class="p-button-text back-button cursor-pointer"
                    @click="goBack" />
            </div>

            <div v-if="currentView.type === 'list'">
                <div class="flex align-items-end justify-content-end gap-2">
                    <Button label="Add a Student" class="yellow-button-small" @click="createNewStudent" />
                    <Button label="Pending Invitations" class="yellow-button-small" @click="gopendingStudents" />
                </div>

                <div v-if="Students.length" class="grid-container md:p-4">
                    <div v-for="student in Students" :key="student._id">
                        <SuspendedMemberOverlay :suspended="!!student.instituteAccessSuspended"
                            member-type="student">
                        <Card class="Card p-4 h-full">
                            <template #content>
                                <div class="flex flex-column align-items-start justify-content-start gap-2 text-sm">
                                    <div class="flex justify-content-start gap-2 ">
                                        <Avatar
                                            :image="imageUrls[student._id] || blankProfile"
                                            alt="Image" class="mr-2 flex-shrink-0" size="xlarge" shape="circle" />
                                        <div class="flex flex-column justify-content-center gap-3 pb-2 ">
                                            <span class="text-left Paragraph-Medium -mb-2 student-name">{{ student.username }}</span>
                                            <span class="Caption">{{ cleanupLables(student.currentEducationLevel)
                                                }}</span>
                                        </div>
                                    </div>
                                    <!-- <div class="flex justify-content-start gap-2">
                                        <span class="Paragraph-Regular"> {{ student.nextClass.classModel?.join(' | ')?.replace('Class','') }}</span>
                                    </div> -->
                                    <div class="flex justify-content-start gap-2 pb-2 ">
                                        <span class="Paragraph-Small"> {{ cleanupLables(student.nextClass?.classModel) || 'No Class Model' }}</span>
                                    </div>
                                    <div class="flex flex-wrap align-items-center justify-content-start gap-2 ">
                                        <span v-for="subject in student.interestedSubjects" :key="subject"
                                            class="flex items-center subjects justify-center px-2 py-2  Caption">
                                            {{ cleanupLables(subject) }}</span>
                                    </div>
                                    <!-- <div class="flex justify-content-start gap-2 pt-2">
                                        <span class="Caption">{{ student.nextClass?.date ? 'Next class date: ' + student.nextClass.date : '\u00A0' }}</span>
                                    </div> -->
                                </div>
                            </template>
                            <template #footer>
                                <div class="flex justify-content-start gap-2 pb-4">
                                    <span class="Caption">{{ student.nextClass?.date ? 'Next class date: ' + student.nextClass.date : 'No any upcoming classes' }}</span>
                                </div>
                                <div class="flex justify-content-center">
                                    <Button label="View" class="yellow-button-small w-8"
                                        @click="viewStudentProfile(student)" />
                                </div>
                            </template>
                        </Card>
                        </SuspendedMemberOverlay>
                    </div>
                </div>

                <div v-else class="flex flex-column align-items-center justify-content-center w-full h-full">
                    <span class="Caption text-gray-700 text-center mb-4">You don’t have any Enrolled students yet,
                        please schedule a class with a student to get enrolled.</span>
                </div>
            </div>

            <div v-else-if="currentView.type === 'profile'">
                <StudentProfile :student="currentView.data" @back="goBack" />
            </div>

            <!-- Disclaimer -->
            <div v-if="currentView.type === 'list'" class="text-center w-full max-w-xl mx-auto py-4 px-6 mt-auto pt-6">

                <h3 class="text-lg font-semibold mb-2" style="color: #8B5E00;">
                    Disclaimer
                </h3>

                <p class="text-700 m-0 mb-3" style="font-size: 0.8125rem;">
                    ⚠️ <strong>Important Notice:</strong> All classes, communications, and payments must remain on the ILearn'd Tutors platform. Institutes are responsible for their tutors and students. AI features are provided for educational support only, and academic outcomes cannot be guaranteed.
                </p>

                <p class="text-700 m-0" style="font-size: 0.8125rem;">
                    📢 <strong>Platform Updates:</strong> The Institute Portal is continuously evolving, and new features, tools, and improvements will be released regularly to enhance your experience.
                </p>

            </div>
        </div>

        <Dialog v-model:visible="displayDialog" header="Register New Student" :modal="true"
            class="p-fluid w-11 md:w-6 lg:w-4 xl:w-3 mx-3">

            <div class="field grid align-items-center gap-2 mb-3">
                <label for="username" class="col-12 md:col-3 Label">Username</label>
                <div class="col-12">
                    <InputText id="username" v-model="newStudent.username" required size="small" variant="filled"
                        class="w-full" />
                </div>
            </div>

            <div class="field grid align-items-center gap-2 mb-3">
                <label for="email" class="col-12 md:col-3 Label">Email</label>
                <div class="col-12 ">
                    <InputText id="email" type="email" v-model="newStudent.email" required size="small" variant="filled"
                        class="w-full" />
                </div>
            </div>

            <!-- <div class="field grid align-items-center gap-2 mb-3">
                <label for="password" class="col-12 md:col-3 Label">Password</label>
                <div class="col-12 ">
                    <InputText id="password" type="password" v-model="newStudent.password" required size="small"
                        variant="filled" class="w-full" />
                </div>
            </div> -->

            <template #footer>
                <div class="flex flex-column md:flex-row justify-content-end gap-2 w-full">
                    <Button label="Cancel" class="yellow-button-small w-full md:w-auto"
                        @click="displayDialog = false" />
                    <Button label="Create Student" class="yellow-button-small w-full md:w-auto"
                        @click="handleStudentCreation" :loading="loading" />
                </div>
            </template>
        </Dialog>

    </DashboardLayout>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Breadcrumb from 'primevue/breadcrumb';
import Button from "primevue/button";
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Card from 'primevue/card';
import Avatar from 'primevue/avatar';
import { useToast } from 'primevue/usetoast';
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { getStudents, createStudent } from "@/api/institutes";
import { useAuthStore } from "@/stores/authStore";
import { generateSignedUrl } from "@/api/storage";
import blankProfile from '@/assets/blank-profile.png';
import StudentProfile from "./StudentProfile.vue";
import SuspendedMemberOverlay from "./SuspendedMemberOverlay.vue";
import { cleanupLables } from "@/utils/cleanups";
import { notifyError, notifyWarn } from "@/utils/notification";
import { useRouter } from "vue-router";

const router = useRouter();
const gopendingStudents = () => router.push('/pendingStudents');
const authStore = useAuthStore();
const Students = ref([]);
const profile = ref(null);
const imageUrls = ref({});
const displayDialog = ref(false);
const loading = ref(false);
const keycloakRole = ref(null);

const viewStack = ref([{ type: "list", label: "Our Students", data: null }]);

const items = computed(() => [
    { label: "Dashboard" },
    ...viewStack.value.map(v => ({ label: v.label }))
]);

const currentView = computed(() => viewStack.value[viewStack.value.length - 1]);

const newStudent = ref({ username: '', email: '', /* password: '', */ role: 'student' });

const toast = useToast();

const goBack = () => { if (viewStack.value.length > 1) viewStack.value.pop(); };

const createNewStudent = () => { displayDialog.value = true; };

const viewStudentProfile = (student) => {
    profile.value = student._id;
    viewStack.value.push({ type: "profile", label: "Student Profile", data: student });
};

async function fetchStudentImageUrls(students) {
    for (const student of students) {
        const filePath = student.profilePhotoURL || student.studentPhotoURL;
        if (!filePath || filePath.includes('local environment')) {
            imageUrls.value[student._id] = blankProfile;
            continue;
        }
        try {
            imageUrls.value[student._id] = await generateSignedUrl(filePath);
        } catch (error) {
            imageUrls.value[student._id] = blankProfile;
        }
    }
}

async function fetchStudents() {
    try {
        const response = await getStudents();
        Students.value = response.data.data.students;
        await fetchStudentImageUrls(Students.value);
    } catch (error) {
        if (error.status === 404) Students.value = [];
    }
}

async function handleStudentCreation() {
    loading.value = true;
    try {
        const payload = { ...newStudent.value, role: keycloakRole.value };
        const response = await createStudent(payload);
        console.log('Student created:', response.data);

        toast.add({ severity: 'success', summary: 'Success', detail: 'Student created successfully', life: 3000 });
        displayDialog.value = false;
        newStudent.value = { username: '', email: '', /* password: '', */ role: 'student' };
        await fetchStudents();
    } catch (error) {
        if (error.response?.data?.code === 403) {
            notifyWarn("Plan Limit Reached", error.response.data.message);
        } else {
            notifyError(error.response?.data?.status || "Error", error.response?.data?.message || "Could not create student. Please try again.");
        }
    } finally {
        loading.value = false;
    }
}

onMounted(async () => {
    await fetchStudents();
    keycloakRole.value = await authStore.findKeycloackRole('student');
});
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    gap: 3rem;
}

.card {
    min-height: calc(100vh - 11rem);
}

.Card {
    border-radius: 4px;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
    height: 100%;
}

.Card :deep(.p-card-body) {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
}

.Card :deep(.p-card-content) {
    flex-grow: 1;
    padding-bottom: 0;
}

.Card :deep(.p-card-footer) {
    margin-top: auto;
    padding-top: 1rem;
}

.p-button-danger {
    padding: 10px 16px 10px 16px;
    height: 30px;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

.subjects {
    border: 1px solid var(--gray-700) !important;
    border-radius: 50px;
    background-color: transparent;
}

.student-name {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.flex-shrink-0 {
    flex-shrink: 0;
}

.Card :deep(.p-avatar.p-avatar-xl) {
    width: 4rem;
    height: 4rem;
    flex-shrink: 0;
}

.Card :deep(.p-avatar.p-avatar-xl img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Match the brown/yellow color from image */
:deep(.yellow-button-small) {
    background-color: #8B5E00 !important;
    /* Adjust to exact brown in image */
    border: none !important;
    color: white !important;
    padding: 0.5rem 1.5rem;
    border-radius: 4px;
}

.breadcrumb {
    font-size: 0.9rem;
    color: #666;
}

@media (max-width: 767px) {
  :deep(.yellow-button-small) {
    padding: 0.35rem 0.75rem;
    font-size: 12px;
    white-space: nowrap;
  }
}

</style>